import type { Level, LevelCreate, LevelUpdate } from "@iso27001/shared";
import { apiFetch } from "./client.js";
import type { AuditEntry } from "../components/AuditHistoryModal.js";

interface ListResp<T> { items: T[]; total: number; page: number; pageSize: number; }

function makeLevelApi(base: string) {
    return {
        list: () => apiFetch<ListResp<Level>>(base),
        create: (body: LevelCreate) => apiFetch<Level>(base, { method: "POST", body: JSON.stringify(body) }),
        update: (id: number, body: LevelUpdate) =>
            apiFetch<Level>(`${base}/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
        remove: (id: number) => apiFetch<null>(`${base}/${id}`, { method: "DELETE" }),
        audit: (id: number) => apiFetch<{ items: AuditEntry[] }>(`${base}/${id}/audit`),
    };
}

export const likelihoodLevelsApi = makeLevelApi("/api/likelihood-levels");
export const damageLevelsApi = makeLevelApi("/api/damage-levels");
